import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const socialAnalytics = createAsyncThunk('socialAnalytics/socialAnalytics', async (data) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `social_analytic`,
            params: {
                social_link_id: data.social_link_id,
                profile_analytic_id: data.profile_analytic_id,
                user_id: localStorage.getItem("id"),
                social_url: data.social_url,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        })
        return res
    } catch (error) {
        return error.response || { status: 500, data: { message: 'Network error or timeout' } }
    }
})

const socialAnalyticsSlice = createSlice({
    name: 'socialAnalytics',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addCase(socialAnalytics.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(socialAnalytics.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
                state.error = null;
            } else if (action?.payload?.status === 401) {
                state.data = null;
                state.error = 'Unauthorized';
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.error = action.payload?.data?.message || 'Failed to fetch social link analysis';
                state.data = null;
            }
        });
        builder.addCase(socialAnalytics.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message || 'An error occurred';
            state.data = null;
        });
    }
})

export default socialAnalyticsSlice.reducer;
